import React from 'react';

import { CDashboard } from 'components/Visualization';

import { inventorySummaryWidgets } from './config';

export const CloudInventorySummary = () => {
  return <CDashboard dashboardWidgets={inventorySummaryWidgets} />;
};
